export default function Structure() {
  const structures = [
    {
      icon: 'ri-gamepad-line',
      color: 'from-red-500 to-pink-500',
      title: 'Espaços de Brincadeira e Descoberta',
      description: 'Nossa área Kids e o playground convidam à aventura! São ambientes feitos para encantar e divertir, onde cada brincadeira se transforma em um novo e mágico aprendizado. Venha descobrir a alegria de brincar em segurança!'
    },
    {
      icon: 'ri-shield-check-line',
      color: 'from-yellow-500 to-orange-500',
      title: 'Um Refúgio de Segurança e Tranquilidade',
      description: 'Contamos com um ambiente totalmente seguro e monitorado, pensado para dar a você e seu filho a tranquilidade que merecem. Aqui, cada pequeno explorador se sente protegido, em um espaço onde a serenidade e o cuidado andam de mãos dadas.'
    }
  ];

  return (
    <section id="atividades" className="py-20 bg-gradient-to-b from-red-50 to-white relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-red-50 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-4">
            THE JOY SCHOOL – ESCOLA BILÍNGUE PARTICULAR DE PAULÍNIA
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-6">
            Nossa estrutura
          </h3>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {structures.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className={`w-20 h-20 flex items-center justify-center bg-gradient-to-br ${item.color} rounded-2xl mb-6 shadow-lg mx-auto`}>
                <i className={`${item.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                {item.title}
              </h3>
              <div className="w-16 h-1 bg-gradient-to-r from-slate-600 to-slate-800 mx-auto mb-4 rounded-full"></div>
              <p className="text-gray-700 leading-relaxed text-center">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}